import * as React from 'react';

const ASTERISK_ONLY = /^\s*\*\s*$/;

/**
 * Removes the " *" required-field markers Amplify hardcodes into its screen
 * labels.
 *
 * Every field on every auth screen is required, so the asterisk marks nothing —
 * the convention only carries information on a form that mixes required and
 * optional fields.
 *
 * Amplify builds those labels as two children, e.g. `{I18n.get('Code')} *`, so
 * the marker is its own string node and can be dropped without touching the
 * label text. This walks the element tree the screen already produced; it
 * cannot reach labels a child component renders internally (PhoneField is the
 * one such case — see `required` in authenticator-components.tsx).
 */
export function stripRequiredMarks(node: React.ReactNode): React.ReactNode {
  if (Array.isArray(node)) {
    return React.Children.map(node, stripRequiredMarks);
  }

  if (typeof node === 'string') {
    return ASTERISK_ONLY.test(node) ? null : node;
  }

  if (React.isValidElement(node)) {
    const { children } = node.props as { children?: React.ReactNode };
    if (children === undefined) {
      return node;
    }
    return React.cloneElement(node, node.props as any, stripRequiredMarks(children));
  }

  return node;
}
